/**
 * Sysadmin Audit Chain — legacy redirect (#761).
 *
 * The canonical Audit Chain Integrity surface lives at
 * `/sysadmin/audit/integrity`. Some operator bookmarks, runbooks, and
 * Phase 2 test matrices still link `/sysadmin/audit-chain` directly. We
 * keep that URL accessible by redirecting it to the real route instead
 * of rendering a generic "Not Found" page.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/sysadmin/audit-chain')({
  beforeLoad: () => {
    throw redirect({ to: '/sysadmin/audit/integrity' });
  },
});
